// src/pages/services/Training.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Training.module.css';

const Training = () => {
  const trainings = [
    {
      title: "Planning and Scheduling Fundamentals",
      audience: "Ideal for project engineers, site supervisors, coordinators, emerging planners, and organisations looking to uplift their project controls capability.",
      overview: "This course introduces the essential principles, techniques, and tools used in modern project scheduling. Through demonstrations, exercises, and real project examples, participants learn how to build effective schedules, identify the critical path, manage progress, and communicate schedule outcomes.",
      outcomes: [
        "Understand Planning & Scheduling Concepts",
        "Introduction to Scheduling Software (P6 / MS Project)",
        "Develop a Schedule from First Principles",
        "Analyse & Validate Schedules",
        "Monitor & Update Schedules During Construction",
        "Reporting & Communication"
      ]
    },
    {
      title: "Earned Value Management (EVM) Training",
      audience: "Ideal for planners, schedulers, project engineers, cost controllers, contract administrators, and project managers looking to strengthen their project controls capability.",
      overview: "This program provides an end-to-end understanding of Earned Value management from establishing performance baselines to reporting variances and forecasting final outcomes. Participants learn how to integrate schedule and cost data, measure progress, and communicate performance insights using EVM metrics.",
      outcomes: [
        "Understand the Foundations of EVM",
        "Establish an Earned Value Baseline",
        "Measure Progress & Calculate EVM Metrics",
        "Forecast Project Outcomes",
        "Integrate EVM With Schedule & Cost Systems",
        "EVM Reporting & Dashboards"
      ]
    },
    {
      title: "Schedule Risk Analysis (SRA) Training",
      audience: "Ideal for planners, schedulers, project managers, risk managers, project controls teams, and professionals involved in forecasting, governance, and high-value project delivery.",
      overview: "This course provides a complete understanding of how schedule risk analysis works—from identifying risk drivers to running Monte Carlo simulations and interpreting probabilistic outcomes. Participants learn how to enhance traditional scheduling with risk-based insights for better decision-making.",
      outcomes: [
        "Foundations of Schedule Risk Analysis",
        "Qualitative Schedule Risk Techniques",
        "Quantitative Risk Analysis (QSRA)",
        "Identifying Key Risk Drivers",
        "Scenario & Mitigation Modelling",
        "Integrating SRA With Schedule & Project Controls",
        "Reporting & Governance"
      ]
    }
  ];

  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <h1 className={styles.heroTitle}>Professional Training & Capability Uplift</h1>
        <p className={styles.heroText}>
          Build in-house expertise with <strong>practical, industry-proven training</strong> — delivered by consultants who use these tools daily on live projects.
        </p>
        <Link to="/contact" className={styles.heroButton}>
          Enquire About Training
        </Link>
      </section>

      {/* Intro & Training Grid */}
      <section className={styles.section}>
        <div className={styles.contentContainer}>
          <p className={styles.introText}>
            At Nulek Consulting, we deliver practical, industry-focused training designed to build strong foundational and advanced skills in project planning, scheduling, risk, and performance measurement — empowering teams to deliver projects with greater confidence and control.
          </p>

          <h2 className={styles.sectionTitle}>Our Training Programs</h2>

          <div className={styles.trainingGrid}>
            {trainings.map((t, idx) => (
              <div key={idx} className={styles.trainingCard}>
                <h3 className={styles.trainingTitle}>{t.title}</h3>
                <p className={styles.audience}>{t.audience}</p>

                <h4 className={styles.sectionSubtitle}>Training Overview</h4>
                <p className={styles.overview}>{t.overview}</p>

                <h4 className={styles.sectionSubtitle}>Key Learning Outcomes</h4>
                <ul className={styles.outcomesList}>
                  {t.outcomes.map((outcome, i) => (
                    <li key={i} className={styles.outcomeItem}>{outcome}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Training;